/**
* DevExpress HTML/JS Reporting (designer\wizard\internal\_labelWizardUtils.js)
* Version:  23.1.4
* Build date: Jul 18, 2023
* Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
export var CONVERSION_COEEFICIENT = 0.0393701;
